import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { detectLocale, setLocaleCookie } from "./locale-cookie";
import { getI18nResources } from "./load-resources";
import { DEFAULT_LOCALE } from "./locales";

const resources = getI18nResources();
const supportedLocales = Object.keys(resources);

void i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: detectLocale(supportedLocales),
    fallbackLng: DEFAULT_LOCALE,
    keySeparator: false,
    nsSeparator: false,
    contextSeparator: "__rc__",
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

i18n.on("languageChanged", setLocaleCookie);

export { default } from "i18next";
